module.exports = __webpack_public_path__ + "img/Ireland.7d28bb64.png";